// Service-worker registration, kept out of main.tsx so the failure policy lives
// next to the feature it protects.
//
// Everything here is best-effort. Offline study is an ENHANCEMENT: a browser
// that refuses the worker (private mode, an old iOS, a locked-down MDM profile)
// must still get the full app, just without downloadable lessons. So every
// failure is swallowed and reported through `offlineSupported()` rather than
// thrown at a user who did not ask for any of this.

let registration: ServiceWorkerRegistration | null = null;

export function offlineSupported(): boolean {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator && 'caches' in window;
}

export function registerOfflineWorker(): void {
  if (!offlineSupported()) return;
  // The worker only matters once the page is interactive; registering during
  // load competes with the app's own bundles for the connection.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => { registration = reg; })
      .catch(() => { /* enhancement only — never surface this */ });
  });
}

export function getRegistration(): ServiceWorkerRegistration | null {
  return registration;
}
